// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.res.mjs";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as React$1 from "@headlessui/react";
import * as Theme$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Theme.res.mjs";
import * as Icons$LiteracyplanetClientSxEntry from "./Icons.res.mjs";
import * as SystemFlags$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SystemFlags.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as FontAwesomeIcon$LiteracyplanetClientSxEntry from "../FontAwesomeIcon.res.mjs";

function InitialsMenu$ItemButton(props) {
  return React.createElement("button", {
              className: "cursor-pointer w-full text-[#0c9ce5] relative focus-visible:text-[#0872a8] hover:text-[#0872a8] pt-[100%]",
              title: props.title,
              onClick: props.onClick
            }, React.createElement("div", {
                  className: "absolute inset-0 justify-center items-center flex"
                }, props.children));
}

var ItemButton = {
  make: InitialsMenu$ItemButton
};

function InitialsMenu$InitialsWidget(props) {
  var r = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.borderRadius,
          8
        ],
        tl: {
          hd: [
            Css.fontSize,
            22
          ],
          tl: {
            hd: [
              Css.width,
              90
            ],
            tl: {
              hd: [
                Css.height,
                62
              ],
              tl: /* [] */0
            }
          }
        }
      });
  var responsive = Curry._1(Css.merge, {
        hd: r,
        tl: {
          hd: "InitialsWidget",
          tl: /* [] */0
        }
      });
  return React.createElement("div", {
              className: TailwindMerge.twMerge("cursor-pointer relative flex flex-col items-center justify-center bg-white fill-[#0c9ce5] font-sx font-bold text-[#0c9ce5] shadow-md shadow-black/50 hover:text-[#0872a8] hover:fill-[#0872a8]", responsive)
            }, props.children);
}

var InitialsWidget = {
  make: InitialsMenu$InitialsWidget
};

function InitialsMenu$NavigationContainer(props) {
  var r = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.marginTop,
          10
        ],
        tl: {
          hd: [
            Css.borderRadius,
            8
          ],
          tl: {
            hd: [
              Css.gap,
              8
            ],
            tl: {
              hd: [
                Css.width,
                62
              ],
              tl: /* [] */0
            }
          }
        }
      });
  var r2 = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.paddingTop,
          8
        ],
        tl: {
          hd: [
            Css.paddingBottom,
            8
          ],
          tl: {
            hd: [
              Css.paddingLeft,
              2
            ],
            tl: {
              hd: [
                Css.paddingRight,
                2
              ],
              tl: /* [] */0
            }
          }
        }
      });
  var responsive = Curry._1(Css.merge, {
        hd: r,
        tl: {
          hd: r2,
          tl: {
            hd: "NavigationContainer",
            tl: /* [] */0
          }
        }
      });
  return React.createElement("div", {
              className: TailwindMerge.twMerge("box-border flex select-none flex-col items-center border-4 border-white bg-white font-sx shadow-md shadow-black/50", responsive),
              id: "initials-panel"
            }, props.children);
}

var NavigationContainer = {
  make: InitialsMenu$NavigationContainer
};

function InitialsMenu$NotificationIcon(props) {
  var responsive = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.fontSize,
          22
        ],
        tl: {
          hd: [
            Css.top,
            -12
          ],
          tl: {
            hd: [
              Css.right,
              -14
            ],
            tl: {
              hd: [
                Css.width,
                28
              ],
              tl: {
                hd: [
                  Css.height,
                  28
                ],
                tl: /* [] */0
              }
            }
          }
        }
      });
  return React.createElement("div", {
              className: TailwindMerge.twMerge("absolute flex flex-col items-center justify-center rounded-full bg-red-600 font-sx font-bold text-white", responsive)
            }, props.children);
}

var NotificationIcon = {
  make: InitialsMenu$NotificationIcon
};

function InitialsMenu$MenuOpenIcon(props) {
  var responsive = Theme$LiteracyplanetClientFlags.resize({
        hd: [
          Css.width,
          18
        ],
        tl: {
          hd: [
            Css.height,
            18
          ],
          tl: /* [] */0
        }
      });
  return React.createElement("div", {
              "aria-hidden": true,
              "aria-controls": "initials-panel",
              className: TailwindMerge.twMerge("transition-transform group-data-[open]:rotate-180", responsive)
            }, React.createElement(Icons$LiteracyplanetClientSxEntry.MenuOpenIcon.make, {}));
}

var MenuOpenIcon = {
  make: InitialsMenu$MenuOpenIcon
};

function InitialsMenu$LogOutLinkButton(props) {
  return React.createElement(InitialsMenu$ItemButton, {
              onClick: props.onClick,
              title: "Log out",
              children: React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                    iconName: "right-from-bracket",
                    className: TailwindMerge.twMerge("h-auto w-10/12")
                  })
            });
}

var LogOutLinkButton = {
  make: InitialsMenu$LogOutLinkButton
};

function InitialsMenu$ThemePickerButton(props) {
  var refreshApp = props.refreshApp;
  var match = Curry._1(SystemFlags$LiteracyplanetClientFlags.use, undefined);
  var setSystemFlag = match.setSystemFlag;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var hasSecondary = Curry._1(hasFlag, "StudentHasSecondary");
  var onClick = function (_evt) {
    Curry._2(setSystemFlag, "StudentHasSecondary", !hasSecondary);
    Curry._1(refreshApp, undefined);
  };
  return React.createElement(InitialsMenu$ItemButton, {
              onClick: onClick,
              title: "Change Theme",
              children: React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                    iconName: "image",
                    prefix: hasSecondary ? "fas" : "far",
                    className: TailwindMerge.twMerge("h-auto w-10/12")
                  })
            });
}

var ThemePickerButton = {
  make: InitialsMenu$ThemePickerButton
};

function InitialsMenu(props) {
  var onClickLogout = props.onClickLogout;
  var collectionNotificationCount = props.collectionNotificationCount;
  var iconSize = Curry._1(Css.merge, {
        hd: Theme$LiteracyplanetClientFlags.resize({
              hd: [
                Css.width,
                30
              ],
              tl: /* [] */0
            }),
        tl: /* [] */0
      });
  return React.createElement(React$1.Popover, {
              className: "group",
              children: null
            }, React.createElement(React$1.Popover.Button, {
                  "aria-label": "Settings Menu",
                  title: "Settings Menu",
                  children: React.createElement(InitialsMenu$InitialsWidget, {
                        children: null
                      }, collectionNotificationCount > 0 ? React.createElement(InitialsMenu$NotificationIcon, {
                              children: String(collectionNotificationCount)
                            }) : null, React.createElement("div", {
                            className: "inline-flex items-center gap-1 "
                          }, React.createElement(FontAwesomeIcon$LiteracyplanetClientSxEntry.make, {
                                iconName: "cog",
                                prefix: "fas",
                                className: TailwindMerge.twMerge("text-[#0c9ce5]", iconSize),
                                ariaHidden: true
                              }), React.createElement("div", {
                                "aria-hidden": true,
                                className: "select-none"
                              }, props.userInitials)), React.createElement(InitialsMenu$MenuOpenIcon, {}))
                }), React.createElement(React$1.Popover.Panel, {
                  className: "z-[1400] px-2 pb-3 transition duration-200 ease-in-out data-[closed]:-translate-y-1 data-[closed]:opacity-0",
                  anchor: "bottom",
                  transition: true,
                  children: React.createElement(InitialsMenu$NavigationContainer, {
                        children: null
                      }, React.createElement(InitialsMenu$ThemePickerButton, {
                            refreshApp: props.refreshApp
                          }), React.createElement(InitialsMenu$LogOutLinkButton, {
                            onClick: (function (param) {
                                Curry._1(onClickLogout, undefined);
                              })
                          }))
                }));
}

var ratio = Theme$LiteracyplanetClientFlags.resize;

var make = InitialsMenu;

export {
  ratio ,
  ItemButton ,
  InitialsWidget ,
  NavigationContainer ,
  NotificationIcon ,
  MenuOpenIcon ,
  LogOutLinkButton ,
  ThemePickerButton ,
  make ,
}
/* Css Not a pure module */
